import { chatEpic as epic } from './epic'
import { chatReducer as reducer } from './reducer'

export const chatEpic = epic
export const chatReducer = reducer
